import styled from '../../../styled';
export const RowDefaultWrapper = styled.div `
  ${ /* for custom RowWrapperComponent */''}
  > * {
    width: 100%;
    height: 100%;
  }
`;
export const RowItemContainer = styled.div `
  height: 3.75rem;
  cursor: pointer;
  user-select: none;

  &:not(:last-child) {
    border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.PRIMARY_100};
  }

  ${({ isSelected, theme }) => isSelected && `background: ${theme.colors.PRIMARY_200};`}

  ${({ isDisabled }) => isDisabled &&
    `
  cursor: not-allowed;

  > div {
    opacity: 0.2;
  }
`}

  display: flex;

  .checkboxColumn {
    display: flex;
    align-items: center;
    padding: 0.5rem;

    // fix Checkbox style
    > label {
      margin-bottom: 0;
    }
  }
`;
//# sourceMappingURL=Row.js.map